module.exports = __webpack_public_path__ + "img/hb-back.5791643c.png";